import React from "react";
import { DetailFieldLabel, DetailFieldValue } from "./detail-page.styles";

interface DetailFieldProps {
  label: string;
  value?: React.ReactNode;
}

export function DetailField({ label, value }: DetailFieldProps) {
  const isEmpty = value === undefined || value === null || value === "";

  return (
    <div>
      <DetailFieldLabel>{label}</DetailFieldLabel>
      <DetailFieldValue>{isEmpty ? "-" : value}</DetailFieldValue>
    </div>
  );
}

export { DetailCard, DetailSectionTitle } from "./detail-page.styles";
